import { useEffect } from "react"
import { publishCompletedTracks } from "@/lib/tracks/publishTracks"

/**
 * Recovers saved tracks that never made it from IndexedDB into PowerSync —
 * the app was killed between saving and the hand-off, or a legacy build left
 * a track pending upload. Saving a track already kicks off a pass of its own
 * (see useActiveTrack.completeTrack), so this only has to catch what that
 * missed: once on start, and again whenever the app returns to the
 * foreground. The hand-off is local (no network), so no timer is needed.
 */
export function useTrackPublisher(canSync: boolean) {
  useEffect(() => {
    if (!canSync) return

    void publishCompletedTracks()

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") void publishCompletedTracks()
    }
    document.addEventListener("visibilitychange", handleVisibilityChange)
    return () =>
      document.removeEventListener("visibilitychange", handleVisibilityChange)
  }, [canSync])
}
